<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="cancelar"
    >
      <template slot="conteudo">
        <divisoria-descricao
          :titulo="'Assinantes de Webhooks'"
          :descricao="'Configure os serviços que receberão notificações de eventos.'"
        />
        <configuracao-api-row
          v-for="(api, $index) in assinantes"
          :key="$index"
          :value="api"
          :dados="assinantes"
          :tipos-evento="tiposEvento"
          :item-acesso="$index"
          @novo="adicionarAssinante()"
          @remove="removerAssinante($event)"
        />
      </template>
    </cadastro-base>
  </div>
</template>
<script>
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'
import api from '../services/api'

export default {
  name: 'WebhooksConfiguracao',
  components: {
    CadastroBase,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    ConfiguracaoApiRow: () => import('./WebhooksConfiguracaoRow.vue'),
  },
  props: {
    configuracoes: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      assinantes: (this.configuracoes.assinantes || []).map(a => ({ ...a, modified: false })),
      tiposEvento: this.configuracoes.tiposEvento || [],
    }
  },
  watch: {
    assinantes: {
      handler() {
        this.garantirRowVazia()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.carregar()
  },
  methods: {
    garantirRowVazia() {
      const last = this.assinantes[this.assinantes.length - 1]
      if (!last || last.nome || last.tipoEvento !== null || last.urlDestino || last.secretKey) {
        this.assinantes.push({
          id: null,
          nome: null,
          tipoEvento: null,
          urlDestino: null,
          secretKey: null,
          ativo: true,
          modified: false,
        })
      }
    },
    carregar() {
      api.getConfiguracaoWebhook()
        .then(payload => {
          this.tiposEvento = payload.data.tiposEvento || []
          this.assinantes = (payload.data.assinantes || []).map(a => ({ ...a, modified: false }))
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        const AssinantesModificados = this.assinantes.filter(assinante => assinante.nome && assinante.tipoEvento !== null && assinante.urlDestino && !this.isRowVazia(assinante))
        api.addAssinante(AssinantesModificados)
          .then(() => {
            this.assinantes = this.assinantes.map(assinante => ({ ...assinante, modified: false }))
            resolve('Salvo com sucesso')
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    isRowVazia(assinante) {
      return !assinante.nome && (assinante.tipoEvento === null || assinante.tipoEvento === undefined) && !assinante.urlDestino && !assinante.secretKey
    },
    cancelar() {
    },
    async removerAssinante(index) {
      const assinante = this.assinantes[index]
      if (assinante && assinante.id) {
        try {
          await api.deleteAssinantes([assinante.id])
          this.assinantes.splice(index, 1)
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao remover assinante',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: e.message || 'Não foi possível remover o assinante.',
            },
          })
        }
      } else {
        this.assinantes.splice(index, 1)
      }
    },
    adicionarAssinante() {
      // Não é mais necessário chamar manualmente, pois garantirRowVazia cuida disso
    },
    // Adicione um método para marcar como modificado
    marcarModificado(index) {
      if (this.assinantes[index]) {
        this.assinantes[index].modified = true
      }
    },
  },
}
</script>
